import {
  mapUsersViewQuery,
  usersSearchSchema,
  usersViewColumns,
} from "./UsersView.default";
import ManagedGridView from "../controls/ManagedGridView";
import { SearchQuery } from "../code/search-query/search-query";
import { getPlatformUsers } from "../repository/data.repository";
import { createGridRequest } from "../hooks/useGridRequest";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";

export interface UsersViewProps {
  readonly trigger?: string;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
  readonly onAction?: (key: string, record: any) => void;
}

function UsersView(props: UsersViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={usersViewColumns}
      schema={usersSearchSchema}
      mapQuery={mapUsersViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getPlatformUsers, { retry: true })}
      actions={[
        {
          key: "view",
          label: "View",
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          danger: true,
          disabled: !permissions.can("PlatformUsers", "delete"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default UsersView;
